import type {
  AttachmentDto,
  AuditEventDto,
  CreateUserPayload,
  DirectoryUserDto,
  SessionUser,
  UserDto,
} from "@grizzly/shared";
import { BASE_URL, postForm, request } from "../http.js";

export function attachmentContentUrl(id: string): string {
  return `${BASE_URL}/attachments/${id}/content`;
}

export const authAndUsersApi = {
  login: (email: string, password: string) =>
    request<{ user: SessionUser }>("/auth/login", {
      method: "POST",
      body: { email, password },
    }),
  logout: () => request<{ ok: boolean }>("/auth/logout", { method: "POST", body: {} }),
  me: () => request<{ user: SessionUser }>("/auth/me"),

  listUsers: () => request<{ items: UserDto[] }>("/users?limit=100"),
  createUser: (payload: CreateUserPayload) =>
    request<{ user: UserDto }>("/users", { method: "POST", body: payload }),
  changeUserRole: (id: string, role: SessionUser["roleKey"]) =>
    request<{ user: UserDto }>(`/users/${id}/role`, { method: "POST", body: { role } }),
  deactivateUser: (id: string, reason: string) =>
    request<{ user: UserDto }>(`/users/${id}/deactivate`, {
      method: "POST",
      body: { reason },
    }),
  activateUser: (id: string, reason: string) =>
    request<{ user: UserDto }>(`/users/${id}/activate`, {
      method: "POST",
      body: { reason },
    }),
  listDirectory: () => request<{ items: DirectoryUserDto[] }>("/directory/users"),

  listAttachments: (ownerType: string, ownerId: string) =>
    request<{ items: AttachmentDto[] }>(
      `/attachments?ownerType=${ownerType}&ownerId=${encodeURIComponent(ownerId)}`
    ),
  uploadAttachment: (input: { ownerType: string; ownerId: string; file: File }) => {
    const form = new FormData();
    form.set("ownerType", input.ownerType);
    form.set("ownerId", input.ownerId);
    form.set("file", input.file, input.file.name);
    return postForm<{ attachment: AttachmentDto }>("/attachments", form);
  },
  deleteAttachment: (id: string, reason: string) =>
    request<{ ok: boolean }>(`/attachments/${id}/delete`, {
      method: "POST",
      body: { reason },
    }),
  listAuditEvents: (action?: string) =>
    request<{ items: AuditEventDto[] }>(
      `/audit-events?limit=50${action ? `&action=${encodeURIComponent(action)}` : ""}`
    ),
};
